import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import { translate } from 'react-i18next';
import Display from '../../../Display';
import { GeozonesTab } from '../Geozones/GeozonesTab';
import { editVehicleClick, editDeviceNameClick } from './actions';
import { GeozoneCreatePage, GeozonePage } from '../../GeozonesModal/GeozoneCreatePage';

@translate(['modal'], { wait: true })
class VehiclesSettings extends Component {
  constructor(props) {
    super(props);
    const { currentDevice } = props;
    this.state = {
      name: currentDevice.name || '',
      tabIndex: 0,
    };
    this.handleSave = this.handleSave.bind(this);
    this.changeTabIndex = this.changeTabIndex.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { currentDevice } = this.props;
    if (currentDevice && nextProps.currentDevice && nextProps.currentDevice.id !== currentDevice.id) {
      this.setState({ name: nextProps.currentDevice.name, tabIndex: 0 });
    }
  }

  handleSave(e) {
    e.preventDefault();
    const { currentDevice } = this.props;

    this.props.editDeviceName({
      name: this.state.name,
      deviceId: currentDevice.id,
    });
  }

  changeTabIndex(e, tabIndex = 0) {
    e.preventDefault();
    this.setState({ tabIndex });
  }

  render() {
    const { t, createGeozoneOpened, currentDeviceStats } = this.props;
    const position = currentDeviceStats.lat ? [currentDeviceStats.lat / 10000000, currentDeviceStats.lon / 10000000] : [0, 0];
    return (
      <div>
        <Display className="popup__content" isShown={!createGeozoneOpened}>
          <h2>{this.state.name}
          </h2>
          <div className="popup__tab-set">
            <div className={cx('popup__tab-set__item', { active: this.state.tabIndex === 0 })} style={{ marginRight: 20 }}>
              <a role="presentation" onClick={e => this.changeTabIndex(e, 0)}>
                {t('modal:vehicle__information')}
              </a>
            </div>
            {this.props.confidants.length
              ? <div className={cx('popup__tab-set__item', { active: this.state.tabIndex === 1 })} style={{ marginRight: 20 }}>
                <a role="presentation" onClick={e => this.changeTabIndex(e, 1)}>
                  {t('modal:vehicle__trusted')}
                </a>
              </div>
              : null
            }
          </div>
          <div className="popup__tab__content">
            {this.state.tabIndex === 0 ? this.renderFirstTab() : null}
            {this.state.tabIndex === 1 ? this.renderSecondTab() : null}
          </div>
        </Display>
      </div>
    );
  }

  renderFirstTab() {
    let { currentDevice, correspondingVehicle, t } = this.props;
    const isVehicleExist = !!correspondingVehicle;
    correspondingVehicle = correspondingVehicle || {};
    return (
      <Display isShown={!!currentDevice}>
        <div id="account__tab-information" className="popup__tab active">
          <form className="popupForm grayPopupForm" action="#">
            <div className="popup__settings-row">
              <div className="popup__settings__title">
                {t('modal:vehicle__header')}
              </div>
              <div className="popup__settings__holder">
                <div className="row">
                  <label className="popupForm__label">
                    {t('modal:vehicle__name')}
                  </label>
                  <div className="wrap">
                    <input
                      className="inputText size14"
                      type="text"
                      value={this.state.name}
                      onChange={(e) => {
                        this.setState({ name: e.target.value });
                      }}
                    />
                    <a href="#" className="btn-save" onClick={this.handleSave}>
                      {t('modal:vehicle__save')}
                    </a>
                  </div>
                </div>
                <div className="row">
                  <label className="popupForm__label">
                    {t('modal:vehicle__vin')}
                  </label>
                  <div className="wrap">
                    <input disabled className="inputText size14" type="text" value={correspondingVehicle.vin || ''} />
                  </div>
                </div>
                <Display isShown={isVehicleExist} className="row colRow">
                  <div className="col col-4">
                    <label className="popupForm__label">
                      {t('modal:vehicle__make')}
                    </label>
                    <div className="wrap">
                      <input disabled className="inputText size14" type="text" value={correspondingVehicle.make || ''} />
                    </div>
                  </div>
                  <div className="col col-5">
                    <label className="popupForm__label">
                      {t('modal:vehicle__model')}
                    </label>
                    <div className="wrap">
                      <input disabled className="inputText size14" type="text" value={correspondingVehicle.model || ''} />
                    </div>
                  </div>
                  <div className="col col-3">
                    <label className="popupForm__label">
                      {t('modal:vehicle__issue-year')}
                    </label>
                    <div className="wrap">
                      <div className="selectWrap size14 hasPlaceholder">
                        <input disabled className="inputText size14" style={{ width: '100%' }} value={correspondingVehicle.issueYear || ''} />
                      </div>
                    </div>
                  </div>
                </Display>
                <Display isShown={isVehicleExist} className="row colRow">
                  <div className="col col-6">
                    <label className="popupForm__label">
                      {t('modal:vehicle__color')}
                    </label>
                    <div className="wrap">
                      <input disabled className="inputText size14" type="text" value={correspondingVehicle.color || ''} />
                    </div>
                  </div>
                  <div className="col col-6">
                    <label className="popupForm__label">
                      {t('modal:vehicle__gov-number')}
                    </label>
                    <div className="wrap">
                      <input disabled className="inputText size14" type="text" value={correspondingVehicle.number || ''} />
                    </div>
                  </div>
                </Display>
              </div>
            </div>
          </form>
        </div>
      </Display>
    );
  }

  renderSecondTab() {
    const { t } = this.props;

    return (
      <div id="account__tab-proxies" className="popup__tab active">
        <form className="popupForm grayPopupForm" action="#">
          {this.props.confidants.length
            ? this.props.confidants.map((c, idx) =>
            (<div key={idx} className="popup__settings-row">
              <div className="popup__settings__title">
                {t('modal:contact')}
                {this.props.confidants.length > 1 ? idx + 1 : ''}
              </div>
              <div className="popup__settings__holder">
                <div className="row">
                  <label className="popupForm__label">
                    {t('modal:contact__name')}
                  </label>
                  <div className="wrap">
                    <input className="inputText size14" type="text" value={c.name} disabled />
                  </div>
                </div>
                {c.phones.map((p, id) =>
                (<div key={id} className="row">
                  <label className="popupForm__label">
                    {t('modal:contact__phone')}
                    {c.phones.length > 1 ? id + 1 : ''}
                  </label>
                  <div className="wrap">
                    <input className="inputText inputTel size14" type="text" value={p.value} disabled />
                  </div>
                </div>),
                )}
              </div>
            </div>),
            )
            : null}
        </form>
      </div>
    );
  }
}

VehiclesSettings.propTypes = {
  vehicle: PropTypes.object,
  device: PropTypes.object,
  confidants: PropTypes.array,
  editVehicle: PropTypes.func,
  editDeviceName: PropTypes.func,
};

export default connect(
  (state) => {
    const cd = state.settings.currentDevice;
    return {
      currentDevice: cd,
      currentDeviceStats: state.devices.currentDeviceStats,
      correspondingVehicle: state.settings.vehicles.filter(v => cd && v.deviceId === cd.id).pop(),
      devicesStats: state.devices.devicesStats,
      vehicle: state.settings.currentVehicle,
      device: state.devices.devices.filter(d => d.id === state.settings.currentVehicle.deviceId).pop(),
      confidants: state.settings.confidants.filter(c => c.deviceId === cd.id),
    };
  },
  dispatch => ({
    editVehicle(vehicle) {
      return dispatch(editVehicleClick({ vehicle }));
    },
    editDeviceName(payload) {
      return dispatch(editDeviceNameClick(payload));
    },
  }),
)(VehiclesSettings);



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/VehiclesSettings/index.js